// components/common/CurrencySelectorPopup/index.jsx
import React from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  IconButton,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Images } from "../../../utils/Images";

const currencyList = [
  { code: "INR", symbol: "₹" },
  { code: "USD", symbol: "$" },
  { code: "AED", symbol: "د.إ" },
  { code: "CAD", symbol: "C$" },
  { code: "AUD", symbol: "A$" },
  { code: "GBP", symbol: "£" },
];

const CurrencySelectorPopup = ({
  open,
  onClose,
  selectedCurrency,
  onCurrencySelect,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const handleCurrencySelect = (currency) => {
    onCurrencySelect(currency);
  };

  const handleClear = () => {
    onCurrencySelect(currencyList[0]); // Default to INR
  };

  const handleSelectAndClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          margin: isMobile ? 0 : "32px",
          borderRadius: isMobile ? "12px 12px 0 0" : "12px",
          maxHeight: isMobile ? "48vh" : "80vh",
          position: isMobile ? "fixed" : "relative",
          bottom: 0,
          top: isMobile ? "auto" : "unset",
     
        },
      }}
    >
      
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{     padding: "20px 16px 0 16px",}}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E6E6E6",
            pb:"16px",
            mb:"12px"
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#0B1215",
            }}
          >
            Select Currency
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <CloseIcon 
              sx={{ 
                fontSize: "20px", 
                color: "#333" 
              }} 
            />
          </IconButton>
        </Box>

        {/* Currency List */}
        <Box sx={{ maxHeight: "400px", overflow: "auto",}}>
          {currencyList.map((currency) => (
            <Box
              key={currency.code}
              onClick={() => handleCurrencySelect(currency)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: "8px 0",
                borderRadius: "8px",
                cursor: "pointer",mb: 1,
                "&:hover": {
                  backgroundColor: "#FFF5F5",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#333",
                }}
              >
                {currency.code}
              </Typography>
              
              {/* Custom Radio Button */}
              <Box
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: selectedCurrency.code === currency.code 
                    ? "6px solid #F04951" 
                    : "2px solid #B9B9B8",
                  backgroundColor: selectedCurrency.code === currency.code ? "transparent" : "transparent",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {selectedCurrency.code === currency.code && (
                  <Box
                    sx={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "#F04951",
                    }}
                  />
                )}
              </Box>
            </Box>
          ))}
        </Box>
 </Box>
        {/* Footer Buttons */}
        <Box
          sx={{
            display: "flex",
            gap: "12px",
            p: "16px",
            boxShadow:"0 -4px 16px 0 rgba(0, 0, 0, 0.10)"
          }}
        >
          <Button
            onClick={handleClear}
            sx={{
              width: "110px",
              backgroundColor: "#FFFFFF",
              color: "#1D1D1B",
              borderRadius: "8px",
              py: 1.5,
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "none",
              border: "1px solid #E6E6E6",
              "&:hover": {
                backgroundColor: "#F5F5F5",
                border: "1px solid #E6E6E6",
              },
            }}
          >
            Clear
          </Button>
          <Button
            onClick={handleSelectAndClose}
            sx={{
              flex: 1,
              backgroundColor: "#F04951",
              color: "#FFFFFF",
              borderRadius: "8px",
              py: 1.5,
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#d63f46",
              },
            }}
          >
            Select
          </Button>
        </Box>
      </DialogContent>
     
    </Dialog>
  );
};

export default CurrencySelectorPopup;